var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glyph",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "orange",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0088ff",
      stopOpacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1230_",
    fill: "url(#grad1)",
    d: "M16,30c-3.401,0-6.626-1.241-9.153-3.433l-1.14,1.14c-0.285,0.285-0.714,0.372-1.09,0.217 C4.243,27.769,4,27.404,4,27v-4c0-0.552,0.447-1,1-1h4c0.404,0,0.77,0.244,0.924,0.617c0.155,0.374,0.069,0.804-0.217,1.09 l-1.444,1.444C10.413,26.971,13.133,28,16,28c7.706,0,13.465-7.215,11.68-14.765c-0.126-0.538,0.207-1.076,0.744-1.203 c0.536-0.131,1.076,0.206,1.203,0.744C31.701,21.595,24.99,30,16,30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1229_",
    fill: "url(#grad1)",
    d: "M3.578,19.978c-0.532,0.128-1.075-0.202-1.203-0.744C0.292,10.404,7.016,2,16,2 c3.428,0,6.645,1.251,9.155,3.431l1.138-1.138c0.286-0.287,0.716-0.371,1.09-0.217C27.757,4.231,28,4.596,28,5v4 c0,0.583-0.516,1-1,1h-4c-0.404,0-0.77-0.244-0.924-0.617c-0.155-0.374-0.069-0.804,0.217-1.09l1.443-1.443 C21.601,5.039,18.889,4,16,4C8.29,4,2.536,11.214,4.322,18.775C4.449,19.312,4.116,19.851,3.578,19.978z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_366_",
    fill: "url(#grad1)",
    d: "M10,11c-1.105,0-2,0.895-2,2v6c0,1.105,0.895,2,2,2h4l6,3v-3h2c1.105,0,2-0.895,2-2v-6c0-1.105-0.895-2-2-2 H10z M11.5,17.5c-0.828,0-1.5-0.672-1.5-1.5c0-0.828,0.672-1.5,1.5-1.5c0.828,0,1.5,0.672,1.5,1.5C13,16.828,12.328,17.5,11.5,17.5z M16,17.5c-0.828,0-1.5-0.672-1.5-1.5c0-0.828,0.672-1.5,1.5-1.5c0.828,0,1.5,0.672,1.5,1.5C17.5,16.828,16.828,17.5,16,17.5z M20.5,17.5c-0.828,0-1.5-0.672-1.5-1.5c0-0.828,0.672-1.5,1.5-1.5c0.828,0,1.5,0.672,1.5,1.5C22,16.828,21.328,17.5,20.5,17.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.bfbf1f1cd2698e2cc3e176dfdb8d8e86.svg";
export { ForwardRef as ReactComponent };